











// vendor
import { defineComponent, computed } from "@vue/composition-api";
// project
import { RunCognitiveTest } from "@/components.run/run-cognitive-test";
// local
import { getProps } from "../../ts/NodeComponent";

type CognitiveTestParams = {
	testType:string,
	testParameters:any
};

export default defineComponent({
	emits:[ "end", "previous" ],
	components:{
		RunCognitiveTest
	},
	props:getProps<CognitiveTestParams>(),
	setup(props, context){

		const type = computed(() => props.node?.parameters.testType);
		const parameters = computed(() => props.node?.parameters.testParameters);

		const onEnd = () => context.emit("end");
		const onBack = () => context.emit("previous");

		return {
			onBack,
			onEnd,
			type,
			parameters
		};
	}
});

